export interface ToggleTmp {
    [sku: string]: ToggleTmpValue 
}

interface ToggleTmpValue {
    enable_get_coupon: boolean,
    enable_now_coupon: boolean,
    enable_free_coupon: boolean
}

export enum CouponType {
    samwatch = "samwatch",
    samtheme = "samtheme", 
    yamwatch = "yamwatch",
}